/**
 * Canonical grade-code display labels (same as grade_levels.label).
 * - 22 or 0 → "K"
 * - 21 or -1 → "TK"
 * - 20 or -2 → "PreK 3"
 * - 19 or -3 → "PreK 2"
 * - 18 or -4 → "PreK 1"
 * - 1–13 → "1"…"13"
 */

const EARLY_CHILDHOOD_GRADE_LABEL: Record<number, string> = {
  [-4]: "PreK 1",
  [-3]: "PreK 2",
  [-2]: "PreK 3",
  [-1]: "TK",
  0: "K",
  18: "PreK 1",
  19: "PreK 2",
  20: "PreK 3",
  21: "TK",
  22: "K",
};

export function formatGradeForDisplay(grade: number | string): string {
  const numGrade = typeof grade === "string" ? Number(grade) : grade;

  if (isNaN(numGrade)) {
    return String(grade);
  }

  const code = Math.floor(numGrade);
  const earlyLabel = EARLY_CHILDHOOD_GRADE_LABEL[code];
  if (earlyLabel !== undefined) {
    return earlyLabel;
  }

  if (code >= 1 && code <= 13) {
    return String(code);
  }

  return String(grade);
}

/**
 * Sort order: alias −4…0 and primary 18–22 (PreK 1 … K) before 1–13.
 */
export function getGradeSortOrder(grade: number | string): number {
  const numGrade = typeof grade === "string" ? Number(grade) : grade;

  if (isNaN(numGrade)) {
    return 999;
  }

  const code = Math.floor(numGrade);

  if (code >= -4 && code <= 0) {
    return code;
  }

  if (code >= 18 && code <= 22) {
    return code - 22;
  }

  return code;
}
